
export type HashtagSearchResponseHashtagsItem = {
  id?: string;
  name?: string;
  tweetCount?: number;
};
